import { EcommerceAPI } from "../Client";

export const getDeliveryChargeApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(`/delivery-charge?id=${payload?.id || 0}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateDeliveryChargeApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/delivery-charge`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postDeliveryChargeApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/delivery-charge`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteDeliveryChargeApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(`/delivery-charge?id=${payload?.id || 0}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDeliveryChargesApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(
      `/delivery-charges?companyId=${payload?.companyId || 0}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
